<template>
  <div class="comment-item my-3 mx-1 row d-flex justify-content-between">
    <div>
      <span class="picture">
        <img v-if="comment.user.picture" class="picture-photo" :src="`${ api_url }/users/${ comment.user.picture }`">
        <img v-else-if="comment.user.is_social && comment.user.social_avatar" class="picture-photo" :src="comment.user.social_avatar">
        <img v-else class="picture-photo" src="../../../../assets/img/mascote.png">
      </span>

      <span class="p-2 name">
        <a target="_blank" :href="`/perfil/${ comment.user.id }/${ comment.user.name }`" class="text-left text-dark mt-4 mb-0">{{ comment.user.name }}</a>
      </span>

      <span class="text p-0 mt-1">
        {{ comment.comment }}
      </span>
    </div>

    <div>
      <span class="delete-comment" v-if="comment.user.id === user.id"  @click="delComment">
        <small>
          <i class="fas fa-trash text-danger"></i>
        </small>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Axios from 'axios'

export default {
  data() {
    return {
      api_url: process.env.VUE_APP_ROOT_BASE
    }
  },
  props: {
    comment: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  methods: {
    delComment: function () {
      Axios.post('/comment/delete', {
        comment: this.comment.id
      })
        .then( () => {
          this.$emit("reloadComments")
        })
    }
  }
}
</script>

<style scoped>
  .delete-comment {
    cursor: pointer;
  }
</style>
